import { px } from '../css.js';

class VirtualRect {
    x;
    y;
    _width;
    _height;
    scrollTop = 0;
    widthChanged = false;
    heightChanged = false;
    constructor(rect) {
        this.x = rect.x;
        this.y = rect.y;
        this._width = rect.width;
        this._height = rect.height;
    }
    get top() {
        return this.y;
    }
    set top(value) {
        this.y = value;
    }
    get bottom() {
        return this.y + this._height;
    }
    set bottom(value) {
        this.y = value - this._height;
    }
    get left() {
        return this.x;
    }
    set left(value) {
        this.x = value;
    }
    get right() {
        return this.x + this.width;
    }
    set right(value) {
        this.x = value - this.width;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        if (value === this._width)
            return;
        this._width = value;
        this.widthChanged = true;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        if (value === this._height)
            return;
        this._height = value;
        this.heightChanged = true;
    }
    /**
     * Adjust the top of the rect without changing the bottom and trying to preserve
     * the visible scroll region. Adjusts both height and scrollTop as needed.
     * @note If the top is already below the given value, does nothing.
     * @returns `true` if a change was made.
     */
    clipTop(value) {
        if (value <= this.y)
            return false;
        const delta = value - this.y;
        this.y = value;
        this.height -= delta;
        this.scrollTop += delta;
        return true;
    }
    /**
     * Adjust the bottom of the rect without changing the top (by adjusting the height).
     * @note If the bottom is already above the given value, does nothing.
     * @returns `true` if a change was made.
     */
    clipBottom(value) {
        if (value >= this.bottom)
            return false;
        this.height = value - this.y;
        return true;
    }
    /**
     * Clip this VirtualRect so that it does not extend beyond the given `rect`.
     * @note This only clips the top and bottom edges, since that's currently all we need.
     * @returns An object indicating which edges were clipped.
     */
    clipRect(rect) {
        const top = this.clipTop(rect.top);
        const bottom = this.clipBottom(rect.bottom);
        return { top, bottom };
    }
    apply(el, scrollContainer) {
        const result = { top: px(this.top), left: px(this.left) };
        if (this.widthChanged) {
            result.width = px(this.width);
        }
        else {
            el.style.removeProperty('width');
        }
        if (this.heightChanged) {
            result.height = px(this.height);
        }
        else {
            el.style.removeProperty('height');
        }
        Object.assign(el.style, result);
        if (scrollContainer) {
            scrollContainer.scrollTop = this.scrollTop;
        }
        else {
            el.scrollTop = this.scrollTop;
        }
    }
}

export { VirtualRect };
//# sourceMappingURL=positioner.virtual-rect.js.map
